import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    SNAPSHOT_USER_TRAINING_PLAN: (userId) => ({ userId }),
    API: {
      SNAPSHOT_USER_TRAINING_PLAN: apiResourceActionCreator('profile')
    }
  }
})

export const apiAction = (authToken, userId) => commonApiActions.authenticated.post(`${API_ENDPOINT}/snapshotTrainingPlan/${userId}`, authToken, {}, action.admin.api.snapshotUserTrainingPlan)

function* snapshotUserTrainingPlan(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.userId));
}

const configuration = {
  name: 'snapshotUserTrainingPlan',
  action: action,
  sagas: snapshotUserTrainingPlan,
  reducers: {
    request: (state, action) => ({
      ...state,
      isTakingSnapshot: true
    }),
    success: (state, action) => {
      const updated = action.payload.profile
      return ({
        ...state,
        isTakingSnapshot: false,
        userData: {
          ...state.userData,
          result: fp.map(
            (existing) => existing.user.id === updated.user.id ? updated : existing
          )(state.userData.result)
        },
        businessUserData: {
          ...state.businessUserData,
          result: fp.map(
            (existing) => existing.user.id === updated.user.id ? updated : existing
          )(state.businessUserData.result)
        }
      })
    },
    failed: (state, action) => ({
      ...state,
      isTakingSnapshot: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/snapshotUserTrainingPlan.js